import jQuery from 'jquery'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import store from './store'
import helpers from '@/helpers'

// FlatPickr: https://flatpickr.js.org/
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css'

import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

Vue.config.devtools = true
Vue.config.productionTip = false

// Common - History.
Vue.component('history-section', require('./components/common/history/HistorySection.vue').default);

// Common - Metric.
Vue.component('metric-kpi-info-section', require('./components/common/metric/kpi/info/MetricKpiInfoSection').default);
Vue.component('metric-kpi-actual-form', require('./components/common/metric/kpi/actual/form/MetricKpiActualForm').default);

// Common - Share.
Vue.component('share-save-form', require('./components/common/share/form/save/ShareSaveForm').default);

// Common - Field.
Vue.component('update-field-value-cmd-form', require('./components/common/field/form-cmd-update-field-value/UpdateFieldValueCmdForm').default);

/*********************/
/* PLANNING MODULE */
/*********************/
Vue.component('media-insertion-invoice-list-info-section', require('./components/modules/planning-module/media-insertion/invoice-list-info/MediaInsertionInvoiceListInfoSection').default);

// MEDIA AUTHORIZATION

/*********************/
/* PRODUCTION MODULE */
/*********************/

// PROJECT TEMPLATE
Vue.component('project-template-save-form', require('./components/modules/production-module/project-template/form-save/ProjectTemplateSaveForm').default);
Vue.component('project-template-delete-form', require('./components/modules/production-module/project-template/form-delete/ProjectTemplateDeleteForm').default);

// PROJECT TIMELOG
Vue.component('project-timelog-save-form', require('./components/modules/production-module/project-timelog/form-save/ProjectTimeLogSaveForm').default);
Vue.component('project-timelog-timer-list-fieldset', require('./components/modules/production-module/project-timelog/fieldset-list-timer/ProjectTimeLogTimerListFieldset').default);

/*********************/
/* ACCOUNTING MODULE */
/*********************/

Vue.component('invoice-save-form', require('./components/modules/accounting-module/invoice/form/save/InvoiceSaveForm').default);
Vue.component('invoice-delete-form', require('./components/modules/accounting-module/invoice/form/delete/InvoiceDeleteForm').default);
Vue.component('invoice-form-cmd-merge', require('./components/modules/accounting-module/invoice/form-cmd-merge/InvoiceMergeCmdForm').default);
Vue.component('invoice-form-cmd-split', require('./components/modules/accounting-module/invoice/form-cmd-split/InvoiceSplitCmdForm').default);

/*********************/
/* MEDIA PLAN MODULE */
/*********************/

// TARGETS
Vue.component('mediaplan-target-save-form', require('./components/modules/mediaplan-module/mediaplan-target/form-save/MediaPlanTargetSaveForm.vue').default);
Vue.component('mediaplan-target-measures-save-form', require('./components/modules/mediaplan-module/mediaplan-target/form-save-measures/MediaPlanTargetMeasuresSaveForm.vue').default);
Vue.component('mediaplan-target-delete-form', require('./components/modules/mediaplan-module/mediaplan-target/form-delete/MediaPlanTargetDeleteForm.vue').default);

/*
 * MEDIA MODULE
 */
Vue.component('media-save-form-date-rule', require('./components/modules/media-module/media/form/save/MediaSaveFormDateRule.vue').default);

/* RATE CARDS */
Vue.component('media-rate-card-save-form', require('./components/media/ratecard/form/save/MediaRateCardSaveForm.vue').default);
Vue.component('media-rate-card-delete-form', require('./components/media/ratecard/form/delete/MediaRateCardDeleteForm.vue').default);

/*
 * PROPOSAL MODULE
 */

/* PROPOSAL */
Vue.component('proposal-save-form', require('./components/proposal/form/save/ProposalSaveForm.vue').default);
Vue.component('proposal-delete-form', require('./components/proposal/form/delete/ProposalDeleteForm.vue').default);

/*
 * ADMINISTRATION MODULE
 */
Vue.component('tag-save-form', require('./components/modules/administration-module/tag/form/save/TagSaveForm.vue').default);

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(helpers)

// Expose JQuery for legacy use.
window.$ = window.jQuery = jQuery;
// Expose flatpickr for legacy use.
window.flatpickr = flatpickr;
// Expose Vue for legacy use.
window.Vue = Vue;
// Expose VueX.
window.store = store;

Vue.prototype.$store = store;

